export default __webpack_public_path__ + "images/IS.27b6cba.png";